import axios from 'axios';
import { EncounterRx } from '../models/encounter-rx';

export const getAppointmentEncounterRxes = async (appointmentId: number): Promise<Undefinable<EncounterRx[]>> => {
    const response = await axios.get(`/api/encounter-rx/appointment/${appointmentId}`);
    return response.data;
};
